import { Button, Form, FormControl, InputGroup } from 'react-bootstrap'
import React, { useCallback } from 'react'
import { Formik } from 'formik'
import { useTranslation } from 'react-i18next'
import { useLayoutStore } from '../../../state/layout.store'
import { packageValidationSchema } from '../../../utils/packageValidation'
import usePackagesRepository from '../../../hooks/usePackagesRepository'
import PackageModel from '@geartrack/shared-lib/dist/PackageModel'

const schema = t => {
  return packageValidationSchema({
    t,
    trackingIdRequiredHelp: t('trackingId.required-homepage', { ns: 'validation' }),
  })
}

const TestingID = 'LY379552862DE'

const InputBar = () => {
  const pkgsRepo = usePackagesRepository()
  const openAddPackageModal = useLayoutStore(state => state.packageModalOpenAndStart)
  const isDarkMode = useLayoutStore(state => state.darkMode)
  const { t } = useTranslation('homepage')

  const savePackage = useCallback(
    id => {
      pkgsRepo.addPackage(PackageModel.create(id))
    },
    [pkgsRepo]
  )

  const manualAdd = useCallback(
    e => {
      e.preventDefault()
      savePackage(TestingID)
    },
    [savePackage]
  )

  const onSubmit = useCallback(
    values => {
      if (values.trackingId.trim().length === 0) return

      openAddPackageModal(values.trackingId.trim())

      // savePackage(values.trackingId)
    },
    [openAddPackageModal]
  )

  return (
    <Formik initialValues={{ trackingId: '' }} validationSchema={schema(t)} onSubmit={onSubmit}>
      {({ values, errors, handleChange, handleBlur, handleSubmit }) => (
        <Form noValidate onSubmit={handleSubmit}>
          <InputGroup hasValidation>
            <FormControl
              name="trackingId"
              className={isDarkMode ? 'bg-dark' : 'bg-white'}
              placeholder={t('input.placeholder')}
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.trackingId}
              isInvalid={!!errors.trackingId}
            />
            <Button variant="primary" type="submit">
              {t('input.button')}
            </Button>
            <Form.Control.Feedback type="invalid">{errors.trackingId as string}</Form.Control.Feedback>
          </InputGroup>
          <div className="text-muted mt-1" style={{ fontSize: '0.8rem' }}>
            {t('input.try')}&nbsp;
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <a href="#" onClick={manualAdd}>
              {TestingID}
            </a>
          </div>
        </Form>
      )}
    </Formik>
  )
}

export default InputBar
